module.exports = __webpack_public_path__ + "img/natural_oak_list.b5abde6f.jpg";